// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"41":"relay-portal","258":"whiteboard","690":"zxcvbn"}[chunkId] + "." + {"41":"8b6b71acdf69","258":"808a6ef708df","690":"b6dc61c1b846"}[chunkId] + ".chunk.min.js";
};